/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// ----------------GENERAL UTILITY FUNCTIONS-----------------
function toggleElementVisibility(el, show){
  if(show && el){
    el.classList.remove('u-visually-hidden');
  }else if(el){
    el.classList.add('u-visually-hidden');
  }
}

function displayAlert(element, alert, kindOfAlert){
  let oldAlerts = element.parentElement.querySelectorAll('.Alert');
  if(oldAlerts.length > 0){
    oldAlerts.forEach((oldAlert)=>{oldAlert.remove()});
  }

  if(alert){
    let alertElement = document.createElement('p');
    alertElement.className = 'Form__Alert Alert Alert--' + kindOfAlert;
    alertElement.innerHTML = alert;
    element.after(alertElement);
  }
}

function getCookie(n) {
  let a = `; ${document.cookie}`.match(`;\\s*${n}=([^;]+)`);
  return a ? a[1] : '';
}

function updateCookie(name, value) {
  let current_cookie = getCookie(name);
  if ((current_cookie && current_cookie != value) || !current_cookie) {
    document.cookie = name + '=' + value + ';expires=Tue, 19 Jan 2100 03:14:07 UTC;path=/;';
  }
}

function deleteCookie(cookie) {
  document.cookie = cookie + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/';
}

function bindPhoneInputs(){
  document.querySelectorAll('input[type="phone"]').forEach((phone)=>{
    window.intlTelInput(phone, {
      separateDialCode: true,
      initialCountry: window.localization.iso_code.toLowerCase()
    });
  });
}

//-------------START Statistics Animation Section-------------------
function StatisticsAnimation(){
  function animateNumberGrowing(stat) {
    const value = parseInt(stat.dataset['value']);
    const duration = parseInt(stat.dataset['duration']);
    const delay = parseInt(stat.dataset['delay']);
    stat.innerHTML = 0;

    let statInterval;

    setTimeout(() => {
      statInterval = setInterval(() => {
        stat.innerHTML = parseInt(stat.innerHTML) < value ? (parseInt(stat.innerHTML) + 1) : stat.innerHTML;
      }, (duration / value));
    }, delay)

    setTimeout(() => {
      clearInterval(statInterval);
      stat.innerHTML = value;
    }, (duration + delay));
  }

  function handleInterseption(entries, observer){
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        animateNumberGrowing(entry.target);
      }
    })
  }

  function init(){
    let stats = document.querySelectorAll('.Stat__Value[data-value]');
    const options = {
      threshold: 0.8
    }
    const observer = new IntersectionObserver(handleInterseption,options)
    stats.forEach((stat)=>{
      observer.observe(stat);
    })
  }


  init();
}

//-------------END Statistics Animation Section-------------------

//-------------START Megamenu-------------------
function megaMenu(){
  function activateMenu(e){
    showSubMenu(e);
    activateMenuLink(e.target);
    showImage(e);
  }

  function showImage(e){
    let menuID = e.target.getAttribute('data-menu'),
      currentMenu = e.target.closest('.MegaMenu__Inner'),
      currentMenuImage = currentMenu.querySelector('.MegaMenu__Push[data-menu="' + menuID + '"]'),
      defaultMenuImage = currentMenu.querySelector('.MegaMenu__Push:not([data-menu])'),
      allimages = currentMenu.querySelectorAll('.MegaMenu__Push');

    allimages.forEach(e =>{
      toggleElementVisibility(e, false);
    })

    if(currentMenuImage){
      toggleElementVisibility(currentMenuImage, true);
    }else{
      toggleElementVisibility(defaultMenuImage, true);
    }
  }

  function activateMenuLink(link){
    let allLinks = link.closest('.MegaMenu__Inner').querySelectorAll('.MegaMenu__Title');
    
    allLinks.forEach(e =>{
      e.classList.remove('is-active');
    })

    link.classList.add('is-active');
  }

  function showSubMenu(e){
    let menuID = e.target.getAttribute('data-menu'),
      submenu = document.querySelector('.Linklist[data-menu="' + menuID + '"]'),
      allSubmenus = e.target.closest('.MegaMenu__Inner').querySelectorAll('.Linklist[data-menu]');

    allSubmenus.forEach(e =>{
      toggleElementVisibility(e, false);
    });
      
    if(submenu){
      toggleElementVisibility(submenu, true);
    }
  }

  function bindMegamenuLinks(){
    let linkElements = document.querySelectorAll('.MegaMenu__Title'),
      subLinksElements = document.querySelectorAll('.MegaMenu .Linklist__Item');
    
    subLinksElements.forEach(e => {
      e.addEventListener('mouseover',showImage);
    })

    linkElements.forEach(e => {
      e.addEventListener('mouseover',activateMenu);
    })
  }

  function init(){
    bindMegamenuLinks();
  }

  init();
}
//-------------END Megamenu-------------------

//-------------START Markets Cookies-------------------
function marketsCookies(){
  function bindMarketSelectors(){
    let country_options = document.querySelectorAll('#footer-currency-popover [name="country_code"], #header-currency-popover-1 [name="country_code"]'),
      language_options = document.querySelectorAll('#footer-locale-popover [name="locale_code"], #header-currency-popover-1 [name="country_code"]');

    country_options.forEach(e => e.addEventListener('click', setMarketCookie));
    language_options.forEach(e => e.addEventListener('click', setMarketCookie));
  }

  function setMarketCookie(event){
    if (event.isTrusted) {
      event.preventDefault();
      if(event.target.name == "country_code"){
        updateCookie('country', event.target.value);
        deleteCookie('language');
      }else{
        updateCookie('language', event.target.value);
      }
      deleteCookie('market');
      updateCookie('open_popup', false);
      event.target.click();
    }
  }

  function init(){
    bindMarketSelectors();
  }

  init();
}
//-------------END Markets Cookies-------------------

//-------------START Collapsible--expandable-------------------
function collapsibleExpandable(){
  function checkCollapsibleHeight(e){
    let parentHeight = e.querySelector('.Collapsible__Inner').offsetHeight,
      childrenHeight = e.querySelector('.Collapsible__Content').offsetHeight;

    if(parentHeight < childrenHeight){
      return true
    }else{
      return false
    }
  }

  function showCollapsibleButton(e){
    let buttonElement = e.querySelector('.Collapsible__Button');

    if(buttonElement){
      buttonElement.removeAttribute('hidden');
    }
  }

  function init(){
    let collapsibleElements = document.querySelectorAll('.Collapsible--expandable');

    if(collapsibleElements.length > 0){
      collapsibleElements.forEach(e => {
        if(checkCollapsibleHeight(e)){
          showCollapsibleButton(e);
        }
      })
    }
  }

  init();
}
//-------------END Collapsible--expandable-------------------

//-------------START Save Register Url in Cookie-------------------
function setLoginPageCookie(){
  sessionStorage.setItem('register_page', window.routes.registerPage)
}
//-------------END Save Register Url in Cookie-------------------

//-------------START Scroll To Top Element-------------------

function scrollToTop(){

  function bindScrollToTopVisibility(scrollToTopElement){
    document.addEventListener('scroll', (e)=>{
      if(window.scrollY > 1000){
        scrollToTopElement.classList.remove('ScrollToTop--hidden');
      }else{
        scrollToTopElement.classList.add('ScrollToTop--hidden');
      }
    })
  }

  function init(){
    let scrollToTopElement = document.querySelector('.ScrollToTop');

    if(scrollToTopElement){
      bindScrollToTopVisibility(scrollToTopElement);
    }
  }

  init()
}

//-------------END Scroll To Top Element-------------------

//-------------START Quantity Validation-------------------
function quantityValidation(){
  const quantities = document.querySelectorAll('.QuantitySelector[data-min-quantity], .QuantitySelector[data-max-quantity]:not([data-min-quantity])');

  function getCart() {
    return fetch(window.routes.cartUrl + '.js', {
      credentials: 'same-origin',
      method: 'GET',
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      }
    }).then(response => response.json());
  }

  function handleSubmit(e){
    if(e.isTrusted){
      e.preventDefault();
      e.stopPropagation();

      try{
        getCart().then(response => {
          const curent_form = e.target.closest('form[action*="/cart/add"]'),
            item_id = curent_form.querySelector('input[name="id"]') ? curent_form.querySelector('input[name="id"]').value : null,
            item_cart_quantity = Number(response.items.filter(item => item.id == item_id).map(item => item.quantity)),
            item_quantity_selected = curent_form.querySelector('.QuantitySelector__CurrentQuantity') ? Number(curent_form.querySelector('.QuantitySelector__CurrentQuantity').value) : null,
            min_quantity = Number(curent_form.querySelector('[data-min-quantity]').getAttribute('data-min-quantity')),
            max_quantity = Number(curent_form.querySelector('[data-max-quantity]').getAttribute('data-max-quantity')),
            error_message = curent_form.querySelector('.Alert--error');

          if(typeof item_cart_quantity == 'number' && typeof item_quantity_selected == 'number'){
            if(min_quantity > (item_cart_quantity + item_quantity_selected)){
              error_message.innerHTML = window.languages.productFormMinQuantity.replace('{{ min_quantity }}',min_quantity);
              error_message.removeAttribute('hidden');
              throw "can't buy less than: " + min_quantity;
            }

            if(max_quantity < (item_cart_quantity + item_quantity_selected)){
              error_message.innerHTML = window.languages.productFormMaxQuantity.replace('{{ max_quantity }}',max_quantity);
              error_message.removeAttribute('hidden');
              throw "can't buy more than: " + max_quantity;
            }

            error_message.setAttribute('hidden', true);
            e.target.click();
          }else{
            e.target.click();
          }
        });
      } catch (error){
        console.error(error);
      }
    }
  }

  function bindSubmit(submit_button){
    if(submit_button){
      submit_button.addEventListener('click', handleSubmit);
    }
  }

  function init(){
    quantities.forEach(quantity => {
      const submit_button = quantity.closest('form[action*="/cart/add"]').querySelector('button[type="submit"]');
      bindSubmit(submit_button);
    })
  }

  init();
}
//-------------END Quantity Validation-------------------

//-------------START Customer B2C Validation-------------------

function customerValidation(){
  if(!window.theme.customerUpdated){
    //call shopify to logout
    fetch('/account/logout').then(()=>{
      document.dispatchEvent('cart:refresh');
    });
  }
}

//-------------END Customer B2C Validation---------------------



//-------------ADD Add To Cart From Card ----------------------

function handleAddToCart(){
  function bindAddToCart() {
    let elements = document.querySelectorAll('form[action$="/cart/add"]');
    if (elements.length > 0) {
      elements.forEach(e => {
        if (!e.closest('[data-section-type="featured-product"]')){
          e.addEventListener('submit', addToCart)
        }
      })
    }
  }

  function addToCart(event){
    event.preventDefault();
    let formElement = event.target.closest('form[action$="/cart/add"]'),
      addToCartButton = event.target,
      formInfo = window.Form.serialize(formElement);

    addToCartButton.setAttribute('disabled', 'disabled');
    document.dispatchEvent(new CustomEvent('theme:loading:start'));

    if (formInfo.items) {
      for (let item in formInfo.items) {
        formInfo.items[item].quantity = formInfo.quantity;
      }
    }

    fetch("".concat(window.routes.cartAddUrl, ".js"), {
      body: JSON.stringify(formInfo, formElement),
      credentials: 'same-origin',
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
      }
    }).then(function (response) {
      document.dispatchEvent(new CustomEvent('theme:loading:end'));
      if (response.ok) {
        addToCartButton.removeAttribute('disabled'); // We simply trigger an event so the mini-cart can re-render
        response.json().then(function(content){
          document.dispatchEvent(new CustomEvent('product:added', {
            bubbles: true,
            detail: {
              variant: content.id,
              quantity: 1
            }
          }))
        });
      }
    })
  }

  function bindQuantitySelectors(){
    let decreaseQuantityElements = document.querySelectorAll('.ProductItem [data-action="decrease-quantity"]'),
      increaseQuantityElements = document.querySelectorAll('.ProductItem [data-action="increase-quantity"]'),
      editQuantityElements = document.querySelectorAll('.ProductItem [name="quantity"]');

    if(decreaseQuantityElements.length > 0){
      decreaseQuantityElements.forEach(e => {
        e.addEventListener('click', decreaseQuantity);
      }) 
    }

    if(increaseQuantityElements.length > 0){
      increaseQuantityElements.forEach(e => {
        e.addEventListener('click', increaseQuantity);
      })
    }

    if(editQuantityElements.length > 0){
      editQuantityElements.forEach(e => {
        e.addEventListener('change', validateQuantity);
      })
    }
  }

  function addToComparison(e, comparisonApi, comparisonButton, productHandle){
    e.preventDefault();
    if(comparisonApi.containsProduct(productHandle)){
      comparisonApi.removeProduct(productHandle);
      comparisonButton.querySelector('[type="checkbox"]').checked = false;
    }else{
      comparisonApi.addProduct(productHandle);
      comparisonButton.querySelector('[type="checkbox"]').checked = true;
    }
  }



  function increaseQuantity(e){
    e.target.previousElementSibling.value = parseInt(e.target.previousElementSibling.value) + 1;
  }

  function decreaseQuantity(e){
    e.target.nextElementSibling.value = Math.max(parseInt(e.target.nextElementSibling.value) - 1, 1);
  }

  function validateQuantity(e){
    e.target.value = Math.max(parseInt(e.target.value) || 1, 1);
  }

  function bindInit(e){
    document.addEventListener('theme:products:reloaded', init);
  }

  function init(){
    bindInit();
    bindAddToCart();
    bindQuantitySelectors();
  }

  init();
}

function bindAddQntyUrl() {

  const productLinks = document.querySelectorAll("a.ProductForm__AddToCart:not(.ProductForm__AddToCart--preorder)");

  for (const productLink of productLinks) {
    productLink.addEventListener('click', clickAdd); 
  }
}

function clickAdd(event) { 

  event.preventDefault()

  var productQnty = event.target.closest(".ProductForm").querySelector(".QuantitySelector__CurrentQuantity").value;
  var productUrl = event.target.getAttribute("href");
  var productQntyUrl = productUrl + "/?quantity=" + productQnty;

  location.assign(productUrl);
  location.replace(productQntyUrl);

}

function getHeaderHeight () {
  const header = document.querySelector('#shopify-section-header');
  if(!header) {
    return
  }
  document.body.style = `--header-height: ${header.offsetHeight}px`
}

//-------------END Add To Cart From Card ----------------------

document.addEventListener('DOMContentLoaded',()=>{
  StatisticsAnimation();
  if(!/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)){
    megaMenu();
  }
  marketsCookies();
  collapsibleExpandable();
  setLoginPageCookie();
  scrollToTop();
  quantityValidation();
  customerValidation();
  handleAddToCart();
  bindAddQntyUrl();
  getHeaderHeight();
});
